import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';

// Matches RemovedCoApplicantHistory.removal_reason NVARCHAR(500)
export const REMOVAL_REASON_MAX_LENGTH = 500;

// "Remove" returns the reason; "Cancel" and the cross return undefined and change nothing
export type RemoveCoApplicantDialogResult = { reason: string } | undefined;

/**
 * Shown on "Remove Co-Applicant": warns which co-applicant details will be removed and
 * captures why before confirming
 */
@Component({
	selector: 'app-remove-co-applicant-dialog',
	templateUrl: './remove-co-applicant-dialog.component.html',
	styleUrls: ['./remove-co-applicant-dialog.component.scss'],
	standalone: true,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		MatDialogModule,
		MatButtonModule,
		MatFormFieldModule,
		MatIconModule,
		MatInputModule,
		MatTooltipModule,
	],
})
export class RemoveCoApplicantDialogComponent {
	private readonly dialogRef = inject(MatDialogRef<RemoveCoApplicantDialogComponent, RemoveCoApplicantDialogResult>);

	readonly reasonMaxLength = REMOVAL_REASON_MAX_LENGTH;
	readonly reason = new FormControl('', {
		nonNullable: true,
		validators: [Validators.required, Validators.maxLength(REMOVAL_REASON_MAX_LENGTH)],
	});

	onRemove(): void {
		const reason = this.reason.value.trim();
		if (!reason) {
			this.reason.setValue('');
			this.reason.markAsTouched();
			return;
		}
		this.dialogRef.close({ reason });
	}
}
